import { appRouterPaths } from "@/services/navigation";
import { RenewSubscriptionPage } from "@/pages/renew-subscription";
import type { RouteProps } from "react-router-dom";

export const renewSubscriptionPageRoute: RouteProps = {
  path: appRouterPaths.renewSubscription,
  element: <RenewSubscriptionPage />,
};
